import { render } from "./legForm.vue?vue&type=template&id=88aa5668"
import script from "./legForm.vue?vue&type=script&lang=js"
export * from "./legForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__